/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedPortfolioTagListPublic } from './PaginatedPortfolioTagListPublic'
import {
  PaginatedPortfolioTagListPublicFromJSON,
  PaginatedPortfolioTagListPublicFromJSONTyped,
  PaginatedPortfolioTagListPublicToJSON,
} from './PaginatedPortfolioTagListPublic'

/**
 *
 * @export
 * @interface EnvelopedPortfolioTagListPortfolioTagListPublic
 */
export interface EnvelopedPortfolioTagListPortfolioTagListPublic {
  /**
   *
   * @type {PaginatedPortfolioTagListPublic}
   * @memberof EnvelopedPortfolioTagListPortfolioTagListPublic
   */
  body: PaginatedPortfolioTagListPublic
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedPortfolioTagListPortfolioTagListPublic
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedPortfolioTagListPortfolioTagListPublic interface.
 */
export function instanceOfEnvelopedPortfolioTagListPortfolioTagListPublic(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedPortfolioTagListPortfolioTagListPublicFromJSON(
  json: any,
): EnvelopedPortfolioTagListPortfolioTagListPublic {
  return EnvelopedPortfolioTagListPortfolioTagListPublicFromJSONTyped(json, false)
}

export function EnvelopedPortfolioTagListPortfolioTagListPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedPortfolioTagListPortfolioTagListPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedPortfolioTagListPublicFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedPortfolioTagListPortfolioTagListPublicToJSON(
  value?: EnvelopedPortfolioTagListPortfolioTagListPublic | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedPortfolioTagListPublicToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
